var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#d80027",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.403 20.773v-1.47h6.528v1.47h-6.528Zm2.174 2.5V8.727h9.02v1.89H14.77v4.431h6.18v1.882h-6.18v6.343h-2.193Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChf);
export default __webpack_public_path__ + "static/media/chf.3301b9bc2038e7c52ab6ff2722385aa3.svg";
export { ForwardRef as ReactComponent };